import _ from 'underscore';
import FlexSearch from 'flexsearch';
import { Plugin } from '@trello/graphql/generated';
import TrelloMarkdown from '@atlassian/trello-markdown';
import { Plugins } from './types';

export const createSearchIndex = (plugins: Plugins) => {
  // a slightly modified version of FlexSearch's native "simple" encoder
  // but re-done to not break on non-roman characters
  // https://github.com/nextapps-de/flexsearch#flexsearch.encoder
  const encoder = (s: string) =>
    s
      .trim()
      .toLocaleLowerCase()
      .replace(/[àáâãäå]/g, 'a')
      .replace(/[èéêë]/g, 'e')
      .replace(/[ìíîï]/g, 'i')
      .replace(/[òóôõöő]/g, 'o')
      .replace(/[ùúûüű]/g, 'u')
      .replace(/[ýŷÿ]/g, 'y')
      .replace(/ñ/g, 'n')
      .replace(/[çc]/g, 'k')
      .replace(/ß/g, 's')
      .replace(/ & /g, ' and ')
      .replace(/[-_/\\]/g, ' ')
      .replace(/[,.?#!@~$%^*()+='"<>[\]{}:;]/g, '')
      .replace(/\s+/g, ' ');

  // a very trimmed down version of FlexSearch's native english stemmer
  // removed as many as I felt comfortable removing
  // stemming is weird with partial searches since stemming truncates text
  // in the both the query and index which is why if you have a stemming
  // rule of ing -> '' as might seem reasonable
  // then searching for 'voti' will not return 'Voting' since that will have
  // been stemmed down to 'vot' and no longer match :(
  const stemming = {
    izer: 'ize',
    ance: '',
    ence: '',
    ness: '',
    able: '',
    ible: '',
    ment: '',
    ful: '',
    ent: '',
    ism: '',
    ize: '',
    ed: '',
    s: '',
  };

  const nameIndex = FlexSearch.create({
    encode: encoder,
    split: /\s+/,
    stemmer: stemming,
    tokenize: 'full',
  });
  const index = FlexSearch.create({
    encode: encoder,
    split: /\s+/,
    stemmer: stemming,
    tokenize: 'full',
  });

  const markdown = new TrelloMarkdown();

  plugins.forEach((plugin) => {
    if (!plugin.listing) {
      return;
    }
    if (plugin.listing.name) {
      nameIndex.add(plugin.id, plugin.listing.name);
    }
    if (plugin.listing.description || plugin.listing.overview) {
      const body = [
        markdown.text(plugin.listing.overview || '').output,
        markdown.text(plugin.listing.description || '').output,
      ].join(' ');
      index.add(plugin.id, body);
    }
  });

  return {
    search(query: string): Plugin[] {
      const nameResults = nameIndex.search(query, 5);
      const bodyResults = index.search(query, 25);
      return _.uniq(nameResults.concat(bodyResults)).map(
        (idPlugin: string) =>
          plugins.find((plugin) => plugin.id === idPlugin) as Plugin,
      );
    },
  };
};

export const SearchHelper = {
  createSearchIndex,
};
